// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"143f94b5","404":"c087f497","787":"ee052eac"}[chunkId] + ".chunk.js";
};